module.exports = __webpack_public_path__ + "img/karengallardo.dc72b003.jpg";